<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-page">
          <div class="card-header">
            <div class="row">
              <div class="col-md-6"><h5>Depoimentos</h5></div>
              <div class="col-md-6"></div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div
                class="col-md-4 mb-4"
                v-for="depoimento in state.depoimentos"
                :key="depoimento.id"
              >
                <a type="button" @click="abrirModal(depoimento.id)">
                  <div class="card card-depo">
                    <div
                      class="card-header cabecalho_pendente"
                      :class="{
                        cabecalho_aprovado: depoimento.status == 'APROVADO',
                      }"
                    >
                      <div class="row">
                        <div class="col-sm-8">
                          <p class="p-top-nome">
                            {{ depoimento.nome }}
                          </p>
                        </div>
                        <div class="col-sm-4">
                          <p class="p-top-nota">Nota: {{ depoimento.nota }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="card-body corpo">
                      <p class="card-text">{{ depoimento.resumo }}...</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="btns_right">
            <router-link to="/clinicas">
              <button type="button" class="btn_cancel">Voltar</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Modal :open="state.modalOpen" @close="state.modalOpen = !state.modalOpen">
      <container>
        <div class="container">
          <div class="row">
            <div class="col-md-10">
              <h2 class="h2-name">{{ state.depoimento.nome }}</h2>
            </div>
            <div class="col-md-2">
              <button
                @click="fecharModal()"
                type="button"
                class="btn_cancel"
                title="Cancelat"
              >
                Cancelar
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-10 offset-sm-1">
              <p class="text-depo">{{ state.depoimento.depoimento }}</p>
              <p class="text-nota mb-4">Nota: {{ state.depoimento.nota }}</p>
              <div class="btns_right">
                <button
                  type="button"
                  class="btn_aprovar"
                  @click="aprovarDepoimento(state.depoimento.id)"
                >
                  Aprovar
                </button>
                <button
                  type="button"
                  class="btn_excluir"
                  @click="deleteDepoimento(state.depoimento.id)"
                >
                  Excluir
                </button>
              </div>
            </div>
          </div>
        </div>
      </container>
    </Modal>
  </div>
</template>
<script>
import Modal from "./../Modal/Modal.vue";
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
import { useRouter } from "vue-router";

export default {
  components: {
    Modal,
  },
  setup() {
    const storage = useStorage();
    const router = useRouter();
    var token = storage.getStorageSync("token");
    const state = reactive({
      depoimentos: [],
      depoimento: { nome: "" },
      modalOpen: false,
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchDepoimentos();
      }
    });
    async function fetchDepoimentos() {
      try {
        const { data } = await services.clinica.getDepoimento({
          id: router.currentRoute._value.params.id,
          token,
        });
        console.log(data);
        state.depoimentos = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function abrirModal(id_depoimento) {
      state.modalOpen = true;
      try {
        const { data } = await services.clinica.getDepoimentoById({
          id_depoimento,
          token,
        });
        console.log(data);
        state.depoimento = data;
      } catch (error) {
        console.log(error);
      }
    }
    function fecharModal() {
      state.modalOpen = false;
    }
    async function deleteDepoimento(id) {
      try {
        const { data } = await services.clinica.deleteDepoimento({
          id,
          token,
        });
        fetchDepoimentos();
        state.modalOpen = false;
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    }
    async function aprovarDepoimento(id) {
      try {
        const { data } = await services.clinica.aprovarDepoimento({
          id,
          token,
        });
        fetchDepoimentos();
        state.modalOpen = false;
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    }
    return {
      state,
      abrirModal,
      fecharModal,
      deleteDepoimento,
      aprovarDepoimento,
    };
  },
};
</script>
<style scoped>
h5 {
  color: #000;
}
tr {
  text-align: center;
}
th {
  color: #fff;
  border-bottom: solid 2px #000 !important;
}
td {
  border-bottom: solid 1px #000 !important;
  color: #000;
}
.btns_right {
  text-align: right;
  margin: 1rem;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: rgb(207, 135, 2);
}
.card-page {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
.cabecalho_aprovado {
  background: #35ff3ca2 !important;
}
.card .cabecalho_pendente {
  background: #ffcc00a2;
}
.card .cabecalho_aprovado,
.card .cabecalho_pendente,
.card .corpo {
  padding: 10px;
}
.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}
#btn_new_user {
  color: #000;
  font-weight: 600;
  padding: 5px;
  border: solid 2px #000;
  border-radius: 5px;
  background-color: rgb(152, 152, 152);
  transition: 0.2s;
}
#btn_new_user:hover {
  background-color: rgb(210, 209, 209);
}
.table-hover > tbody > tr:hover > * {
  color: rgb(0, 0, 0);
  background-color: rgb(225, 225, 225);
}
.card-depo {
  border: solid 1px gray;
  background-color: #fff;
  transition: 0.2s;
}
.card-depo:hover {
  transform: scale(1.02);
  box-shadow: 0 0 12px 5px #c8c7c7;
}
.p-top-nota {
  text-align: right;
  margin-bottom: 0;
  font-weight: 600;
  color: #000;
}
.p-top-nome {
  text-align: left;
  margin-bottom: 0;
  font-weight: 600;
  color: #000;
}
.card-text {
  text-align: left;
  font-weight: 500;
  color: #000;
}
.h2-name {
  color: #000;
}
.text-depo {
  text-align: justify;
  color: #141414;
  font-size: 14pt;
  margin-bottom: 0;
}
.text-nota {
  color: #141414;
  text-align: left;
  font-size: 14pt;
  font-weight: 600;
}
.btn_excluir {
  padding: 5px;
  width: 100px;
  background: rgb(255, 48, 0);
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_excluir:hover {
  background: rgb(182, 33, 0);
}
.btn_aprovar {
  padding: 5px;
  width: 100px;
  background: greenyellow;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_aprovar:hover {
  background: rgb(137, 202, 39);
}
</style>
